<template>

<div id="mce-responses" class="clear">

  <div v-if="item.type == 'error'">

    <div
      class="notification error"
      id="mce-error-response"
      style="display:none"/>

  </div>
  <div v-else-if="item.type == 'success'">

    <div
      class="notification success"
      id="mce-success-response"
      style="display:none"/>

  </div>

</div>

</template>

<script>
export default {
  name: 'Notification',
  props: {
    item: Object
  }
}
</script>

<style lang="scss" scoped>
.notification {
  font-size: 14px;
  text-align: left;
  margin: 10px;
}

.error {
  color: red;
}

.success {}
</style>
